module.exports = __webpack_public_path__ + "img/mono_8.141e4af0.png";